import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useRetailerType } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerType";
import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useQuery as useAchLinkingOfferEligibilityQuery } from "@faire/web-api--source/endpoints/www/api/instrument/ach-linking-offer-eligibility/get-hooks";
import { useQuery as useOrdersTabCountsQuery } from "@faire/web-api--source/endpoints/www/api/order/v2/brand-order-group-counts-by-tab/get-hooks";
import { QueryParameters as BrandFollowsParams } from "@faire/web-api--source/endpoints/www/api/v2/retailers/retailerToken/follows/scroll/get";
import { useQuery as useBrandFavoritesQuery } from "@faire/web-api--source/endpoints/www/api/v2/retailers/retailerToken/follows/scroll/get-hooks";
import { IAchLinkingOfferEligibilityResponse } from "@faire/web-api--source/indigofair/data/IAchLinkingOfferEligibilityResponse";
import { IGetAchMessagingResponse } from "@faire/web-api--source/indigofair/data/IGetAchMessagingResponse";
import { RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP";

const VALID_DROPDOWN_OFFERS: string[] = [
  IGetAchMessagingResponse.AchOfferType.PROACTIVE_LIMIT_INCREASE,
  IGetAchMessagingResponse.AchOfferType.TERMS_PRE_APPROVAL_ACH_LINK,
];

// This is used to fetch the data for the revamped dropdown menu in the header account section.
// We want to fetch this before the user opens the dropdown so that the data is ready to be displayed.
export const useRevampedDropdownData = () => {
  const { isNewUser } = useRetailerType();
  const retailerToken = getRetailer()?.token;
  const { isLinked, name, reviewCount } = usePOSSummary();
  const { hasOccurred: hasSeenR2BHeartIconNotification } = useMilestone(
    RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP
  );

  const { data: brandFavoritesData } = useBrandFavoritesQuery(
    retailerToken ?? "",
    BrandFollowsParams.build({}),
    {
      enabled: !hasSeenR2BHeartIconNotification,
      staleTime: Infinity,
    }
  );

  const { data: ordersTabCountsData } = useOrdersTabCountsQuery({
    staleTime: Infinity,
  });

  const { data: achData } = useAchLinkingOfferEligibilityQuery(
    {
      surface:
        IAchLinkingOfferEligibilityResponse.AchOfferSurface.ACCOUNT_DROPDOWN,
    },
    {
      staleTime: Infinity,
    }
  );

  const numOfPendingOrders = ordersTabCountsData?.action_required_count ?? 0;

  const newFollows = !hasSeenR2BHeartIconNotification
    ? brandFavoritesData?.follows?.length
    : 0;

  const achOfferData =
    achData?.is_eligible &&
    VALID_DROPDOWN_OFFERS.includes(achData?.ach_offer_type ?? "")
      ? achData
      : undefined;

  return {
    isLinked,
    name,
    reviewCount,
    numOfPendingOrders,
    isNewUser,
    newFollows,
    achOfferData,
  };
};
